import * as R from 'ramda'

import en from 'i18n/prioritised_outcome.en.json'
import nb from 'i18n/prioritised_outcome.nb.json'

export const PRODUCTIVITY_FIELD = 'productivity'
export const TURNOVER_FIELD = 'turnover'
export const SICKNESS_ABSENCE_FIELD = 'absence'
export const NO_PRIORITY_FIELD = 'noPriority'

const languages = { en, nb }

export const categoryNames = (language = 'en') =>
  R.pipe(
    R.prop(R.__, languages),
    R.map(R.props(['description', 'label'])),
  )(language)

const getCategories = R.pipe(
  R.values,
  R.map(([_description, label]) => label),
  R.uniq,
)

const getPrioritisedOutcomes = R.pipe(
  R.toPairs,
  R.map(([name, [description, label]]) => ({
    description,
    name,
    label,
  })),
  R.reduceBy(
    (acc, { description, name }) => ({
      ...acc,
      description,
      name,
    }),
    {},
    ({ label }) => label,
  ),
)

export const getOutcomeOrder = language => {
  const [first, second, third] = getCategories(categoryNames(language))

  return [third, second, first]
}

export const getFields = language =>
  getPrioritisedOutcomes(categoryNames(language))

export const getDefaultValues = () => ({
  [NO_PRIORITY_FIELD]: true,
  [PRODUCTIVITY_FIELD]: false,
  [SICKNESS_ABSENCE_FIELD]: false,
  [TURNOVER_FIELD]: false,
})
